import { usePrefetchTable } from '@/legacy/features/table/hooks/usePrefetchTable';
import { TABLE_IDS } from '@/legacy/constants/tableids';
import urls from '@/legacy/config/env';

export const usePrefetchPosTable = () =>
	usePrefetchTable({
		pageKey: 'app__frekuent_spots__points_of_sale',
		tableId: TABLE_IDS.POS_GENERAL,
		endpoint: urls.pointsOfSale.posTable,
		sortBy: 'total_sales',
	});
